import { v4 as uuid } from 'uuid';
var sessionStorageKey = 'ECOS_TELEMETRY_INSTANCE_ID';
export var getInstanceId = function getInstanceId() {
  var instanceId = window.sessionStorage.getItem(sessionStorageKey);

  if (!instanceId) {
    instanceId = uuid();
    window.sessionStorage.setItem(sessionStorageKey, instanceId);
  }

  return instanceId;
};
//# sourceMappingURL=getInstanceId.js.map